/* eslint-disable */
import React, { useState, useMemo } from 'react';
import { Icon, Stars, ProductCard } from './Primitives';

// =================== CART ===================
export const CartPage = ({ cart, updateQty, removeFromCart, onNav, applyPromo, promoState }) => {
  const [code, setCode] = useState('');
  const subtotal = cart.reduce((s, l) => s + l.price * l.qty, 0);
  const discount = promoState.applied ? subtotal * promoState.discount : 0;
  const shipping = subtotal > 40 ? 0 : 6;
  const tax = (subtotal - discount) * 0.08;
  const total = subtotal - discount + shipping + tax;

  if (cart.length === 0) {
    return (
      <div style={{ padding: '120px 24px', textAlign: 'center' }}>
        <span className="eyebrow">Your cart</span>
        <h1 className="bw-cart-title" style={{ fontSize: 64, marginTop: 16 }}>Empty for now.</h1>
        <p style={{ color: 'var(--ink-muted)', marginBottom: 32, fontSize: 16 }}>Browse our spring harvest — we just landed three new lots.</p>
        <button className="bw-btn bw-btn--primary bw-btn--large" onClick={() => onNav('shop')}>Shop coffee <Icon name="arrowSm" className="icon icon--sm" /></button>
      </div>
    );
  }

  return (
    <div className="bw-cart">
      <div>
        <span className="eyebrow">Bag · {cart.length} {cart.length === 1 ? 'item' : 'items'}</span>
        <h1 className="bw-cart-title" style={{ marginTop: 8 }}>Your cart.</h1>
        <div className="bw-cart-count">All coffees roasted to order · ships within 48 hours</div>
        <div className="bw-cart-table">
          {cart.map((l, i) => (
            <div key={i} className="bw-cart-row">
              <div className="bw-cart-img">
                {l.image
                  ? <img src={l.image} alt={l.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  : <div className="bw-cart-img-stripe"></div>
                }
              </div>
              <div className="bw-cart-prod">
                <span className="bw-cart-prod-name">{l.name}</span>
                <span className="bw-cart-prod-meta">
                  {l.origin}{l.size ? ` · ${l.size}` : ''}{l.grind ? ` · ${l.grind}` : ''}
                </span>
                <button className="bw-cart-prod-remove" onClick={() => removeFromCart(i)}>Remove</button>
              </div>
              <div className="bw-qty">
                <button onClick={() => updateQty(i, Math.max(1, l.qty - 1))}>−</button>
                <input value={l.qty} onChange={(e) => updateQty(i, Math.max(1, +e.target.value || 1))} />
                <button onClick={() => updateQty(i, l.qty + 1)}>+</button>
              </div>
              <div className="bw-cart-line-price">${(l.price * l.qty).toFixed(2)}</div>
            </div>
          ))}
        </div>
      </div>
      <aside className="bw-summary">
        <h3>Order summary</h3>
        <div className="bw-summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
        {promoState.applied && (
          <div className="bw-summary-row bw-summary-row--discount"><span>Promo · {promoState.code}</span><span>−${discount.toFixed(2)}</span></div>
        )}
        <div className="bw-summary-row"><span>Shipping</span><span>{shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}</span></div>
        <div className="bw-summary-row"><span>Estimated tax</span><span>${tax.toFixed(2)}</span></div>

        <div style={{ marginTop: 16 }}>
          <label className="bw-field-err" style={{ color: 'var(--ink-muted)', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Promo Code</label>
          <div className="bw-promo">
            <input placeholder="ENTER CODE" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} />
            <button className="bw-btn bw-btn--outline bw-btn--small" onClick={() => applyPromo(code)}>Apply</button>
          </div>
          {promoState.msg && (
            <div className={`bw-promo-msg ${promoState.applied ? 'success' : 'error'}`}>{promoState.msg}</div>
          )}
          <div style={{ fontSize: 11, color: 'var(--ink-faint)', marginTop: 8, fontStyle: 'italic' }}>Try <strong>BREWED10</strong> or <strong>SPRING26</strong></div>
        </div>

        <div className="bw-summary-row bw-summary-row--total"><span>Total</span><span>${total.toFixed(2)}</span></div>
        <button className="bw-btn bw-btn--primary bw-btn--block bw-btn--large" style={{ marginTop: 20 }} onClick={() => onNav('checkout')}>
          Checkout <Icon name="arrowSm" className="icon icon--sm" />
        </button>
        <div className="bw-stripe-note">
          <Icon name="lock" className="icon icon--sm" />
          <span>Secure checkout via</span>
          <span className="bw-stripe-badge">stripe</span>
        </div>
      </aside>
    </div>
  );
};

// =================== CHECKOUT ===================
export const CheckoutPage = ({ cart, promoState, onNav, completeOrder, user }) => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    email: user?.email || '', firstName: '', lastName: '',
    address: '', city: '', state: '', zip: '', country: 'United States',
    cardName: '', cardNum: '', exp: '', cvc: ''
  });
  const [errors, setErrors] = useState({});
  const [pay, setPay] = useState('card');
  const [shipMethod, setShipMethod] = useState('standard');

  const subtotal = cart.reduce((s, l) => s + l.price * l.qty, 0);
  const discount = promoState.applied ? subtotal * promoState.discount : 0;
  const standardShipping = subtotal > 40 ? 0 : 6;

  // Shipping options carry real prices now — selecting Express or Pickup
  // actually changes what gets charged, instead of three uncontrolled
  // radios sitting on top of a shipping total that never moved.
  const SHIP_OPTIONS = [
    { id: 'standard', name: 'Standard · 3–5 business days', price: standardShipping },
    { id: 'express', name: 'Express · 1–2 business days', price: 14 },
    { id: 'pickup', name: 'Pickup · NYC Roastery', price: 0 },
  ];
  const shipping = SHIP_OPTIONS.find(s => s.id === shipMethod)?.price ?? standardShipping;
  const tax = (subtotal - discount) * 0.08;
  const total = subtotal - discount + shipping + tax;

  const update = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErrors(e => ({ ...e, [k]: null })); };

  const validateContact = () => {
    const e = {};
    if (!form.email.match(/.+@.+\..+/)) e.email = 'Enter a valid email';
    if (!form.firstName) e.firstName = 'Required';
    if (!form.lastName) e.lastName = 'Required';
    if (!form.address) e.address = 'Required';
    if (!form.city) e.city = 'Required';
    if (!form.zip || form.zip.length < 5) e.zip = 'Invalid';
    setErrors(e);
    return Object.keys(e).length === 0;
  };
  const validatePayment = () => {
    const e = {};
    if (!form.cardName) e.cardName = 'Required';
    if (!form.cardNum || form.cardNum.replace(/\s/g, '').length < 16) e.cardNum = 'Invalid card';
    if (!form.exp.match(/^\d{2}\/\d{2}$/)) e.exp = 'MM/YY';
    if (!form.cvc || form.cvc.length < 3) e.cvc = 'CVC';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const next = () => {
    if (step === 1 && validateContact()) setStep(2);
    else if (step === 2) setStep(3);
    else if (step === 3 && (pay !== 'card' || validatePayment())) {
      completeOrder({ form, total, items: cart, shipMethod });
    }
  };

  return (
    <div className="bw-checkout">
      <div className="bw-checkout-form">
        <span className="eyebrow">Checkout</span>
        <h1>Almost there.</h1>
        <div className="bw-checkout-steps">
          <div className={`bw-step ${step >= 1 ? (step > 1 ? 'is-done' : 'is-active') : ''}`}>
            <span className="bw-step-num">{step > 1 ? '✓' : '1'}</span>Contact
          </div>
          <div className="bw-step-line"></div>
          <div className={`bw-step ${step >= 2 ? (step > 2 ? 'is-done' : 'is-active') : ''}`}>
            <span className="bw-step-num">{step > 2 ? '✓' : '2'}</span>Shipping
          </div>
          <div className="bw-step-line"></div>
          <div className={`bw-step ${step >= 3 ? 'is-active' : ''}`}>
            <span className="bw-step-num">3</span>Payment
          </div>
        </div>

        {step === 1 && (
          <>
            <div className="bw-form-section">
              <h3>Contact</h3>
              <div className="bw-form-row">
                <div className="bw-field bw-field--full">
                  <label>Email</label>
                  <input className={errors.email ? 'is-error' : ''} value={form.email} onChange={(e) => update('email', e.target.value)} placeholder="you@email.com" />
                  {errors.email && <span className="bw-field-err">{errors.email}</span>}
                </div>
              </div>
            </div>
            <div className="bw-form-section">
              <h3>Shipping address</h3>
              <div className="bw-form-row">
                <div className="bw-field"><label>First name</label><input className={errors.firstName ? 'is-error' : ''} value={form.firstName} onChange={(e) => update('firstName', e.target.value)} /></div>
                <div className="bw-field"><label>Last name</label><input className={errors.lastName ? 'is-error' : ''} value={form.lastName} onChange={(e) => update('lastName', e.target.value)} /></div>
              </div>
              <div className="bw-form-row">
                <div className="bw-field bw-field--full"><label>Address</label><input className={errors.address ? 'is-error' : ''} value={form.address} onChange={(e) => update('address', e.target.value)} placeholder="Street and number" /></div>
              </div>
              <div className="bw-form-row" style={{ gridTemplateColumns: '1.5fr 1fr 1fr' }}>
                <div className="bw-field"><label>City</label><input className={errors.city ? 'is-error' : ''} value={form.city} onChange={(e) => update('city', e.target.value)} /></div>
                <div className="bw-field"><label>State</label><input value={form.state} onChange={(e) => update('state', e.target.value)} /></div>
                <div className="bw-field"><label>ZIP</label><input className={errors.zip ? 'is-error' : ''} value={form.zip} onChange={(e) => update('zip', e.target.value)} /></div>
              </div>
            </div>
          </>
        )}

        {step === 2 && (
          <div className="bw-form-section">
            <h3>Shipping method</h3>
            {SHIP_OPTIONS.map((s) => (
              <label
                key={s.id}
                style={{ display: 'flex', gap: 16, padding: 16, border: `1px solid ${shipMethod === s.id ? 'var(--ink)' : 'var(--line)'}`, borderRadius: 'var(--radius)', marginBottom: 8, cursor: 'pointer', alignItems: 'center' }}
              >
                <input
                  type="radio"
                  name="ship"
                  checked={shipMethod === s.id}
                  onChange={() => setShipMethod(s.id)}
                  style={{ accentColor: 'var(--ink)' }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: 'var(--serif)', fontSize: 16 }}>{s.name}</div>
                </div>
                <div style={{ fontFamily: 'var(--serif)', fontSize: 16 }}>{s.price === 0 ? 'Free' : `$${s.price.toFixed(2)}`}</div>
              </label>
            ))}
          </div>
        )}

        {step === 3 && (
          <div className="bw-form-section">
            <h3>Payment</h3>
            <div className="bw-pay-method">
              <div className={`bw-pay-tab ${pay === 'card' ? 'is-active' : ''}`} onClick={() => setPay('card')}>Credit / Debit</div>
              <div className={`bw-pay-tab ${pay === 'apple' ? 'is-active' : ''}`} onClick={() => setPay('apple')}>Apple Pay</div>
              <div className={`bw-pay-tab ${pay === 'shop' ? 'is-active' : ''}`} onClick={() => setPay('shop')}>Shop Pay</div>
            </div>
            {pay === 'card' && (
              <>
                <div className="bw-form-row">
                  <div className="bw-field bw-field--full"><label>Cardholder name</label><input className={errors.cardName ? 'is-error' : ''} value={form.cardName} onChange={(e) => update('cardName', e.target.value)} /></div>
                </div>
                <div className="bw-form-row">
                  <div className="bw-field bw-field--full"><label>Card number</label><input className={errors.cardNum ? 'is-error' : ''} value={form.cardNum} onChange={(e) => update('cardNum', e.target.value)} placeholder="1234 5678 9012 3456" />
                    {errors.cardNum && <span className="bw-field-err">{errors.cardNum}</span>}</div>
                </div>
                <div className="bw-form-row">
                  <div className="bw-field"><label>Expiry</label><input className={errors.exp ? 'is-error' : ''} value={form.exp} onChange={(e) => update('exp', e.target.value)} placeholder="MM/YY" /></div>
                  <div className="bw-field"><label>CVC</label><input className={errors.cvc ? 'is-error' : ''} value={form.cvc} onChange={(e) => update('cvc', e.target.value)} placeholder="123" /></div>
                </div>
                <label style={{ display: 'flex', gap: 8, fontSize: 13, color: 'var(--ink-muted)', marginTop: 12 }}>
                  <input type="checkbox" defaultChecked style={{ accentColor: 'var(--ink)' }} /> Save card to my account for next time
                </label>
              </>
            )}
            {pay !== 'card' && (
              <div style={{ padding: 32, textAlign: 'center', background: 'var(--cream)', borderRadius: 'var(--radius)', fontSize: 14, color: 'var(--ink-muted)' }}>
                You'll be redirected to {pay === 'apple' ? 'Apple Pay' : 'Shop Pay'} to complete your purchase.
              </div>
            )}
            <div className="bw-stripe-note">
              <Icon name="lock" className="icon icon--sm" />
              <span>Payments encrypted & processed by</span>
              <span className="bw-stripe-badge">stripe</span>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
          {step > 1 && <button className="bw-btn bw-btn--ghost" onClick={() => setStep(step - 1)}>Back</button>}
          <button className="bw-btn bw-btn--primary" style={{ flex: 1 }} onClick={next}>
            {step === 3 ? `Place order · $${total.toFixed(2)}` : 'Continue'} <Icon name="arrowSm" className="icon icon--sm" />
          </button>
        </div>
      </div>

      <aside className="bw-checkout-side">
        <h3 style={{ fontFamily: 'var(--serif)', fontSize: 22, fontWeight: 400, marginBottom: 8 }}>Your order</h3>
        <div className="eyebrow" style={{ marginBottom: 20 }}>{cart.length} items</div>
        {cart.map((l, i) => (
          <div key={i} className="bw-order-line">
            <div className="bw-order-thumb">
              {l.image
                ? <img src={l.image} alt={l.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                : <div className="bw-order-thumb-stripe"></div>
              }
              <span className="bw-order-thumb-qty">{l.qty}</span>
            </div>
            <div className="bw-order-line-info">
              <div className="bw-order-line-name">{l.name}</div>
              <div className="bw-order-line-meta">{l.size || ''} {l.grind ? `· ${l.grind}` : ''}</div>
            </div>
            <div className="bw-order-line-price">${(l.price * l.qty).toFixed(2)}</div>
          </div>
        ))}
        <div style={{ marginTop: 20 }}>
          <div className="bw-summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
          {promoState.applied && <div className="bw-summary-row bw-summary-row--discount"><span>Promo · {promoState.code}</span><span>−${discount.toFixed(2)}</span></div>}
          <div className="bw-summary-row"><span>Shipping</span><span>{shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}</span></div>
          <div className="bw-summary-row"><span>Tax</span><span>${tax.toFixed(2)}</span></div>
          <div className="bw-summary-row bw-summary-row--total"><span>Total</span><span>${total.toFixed(2)}</span></div>
        </div>
      </aside>
    </div>
  );
};

// =================== CONFIRMATION ===================
export const ConfirmationPage = ({ order, onNav }) => {
  const orderNum = useMemo(() => 'BR-' + Math.floor(100000 + Math.random() * 900000), []);
  return (
    <div className="bw-confirm">
      <div className="bw-confirm-mark"><Icon name="check" className="icon" /></div>
      <span className="eyebrow">Order placed</span>
      <h1 style={{ marginTop: 12 }}>Thank you, <em>{order?.form?.firstName || 'friend'}.</em></h1>
      <p className="bw-confirm-lead">We've started roasting. A confirmation has been sent to <strong>{order?.form?.email || 'your inbox'}</strong>.</p>
      <p className="bw-confirm-lead" style={{ fontSize: 14 }}>You'll get tracking the moment your bag leaves the roastery.</p>
      <div className="bw-confirm-order-num">Order № {orderNum}</div>

      <div className="bw-confirm-card">
        <div className="bw-confirm-timeline">
          <div className="bw-tl-step is-done"><div className="bw-tl-dot"></div><div className="bw-tl-line"></div><span className="bw-tl-label">Placed</span></div>
          <div className="bw-tl-step is-active"><div className="bw-tl-dot"></div><div className="bw-tl-line"></div><span className="bw-tl-label">Roasting</span></div>
          <div className="bw-tl-step"><div className="bw-tl-dot"></div><div className="bw-tl-line"></div><span className="bw-tl-label">Shipped</span></div>
          <div className="bw-tl-step"><div className="bw-tl-dot"></div><span className="bw-tl-label">Delivered</span></div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, paddingTop: 20, borderTop: '1px solid var(--line)' }}>
          <div>
            <div className="eyebrow" style={{ marginBottom: 6 }}>Shipping to</div>
            <div style={{ fontFamily: 'var(--serif)', fontSize: 16, lineHeight: 1.4 }}>
              {order?.form?.firstName} {order?.form?.lastName}<br />
              {order?.form?.address}<br />
              {order?.form?.city}, {order?.form?.state} {order?.form?.zip}
            </div>
          </div>
          <div>
            <div className="eyebrow" style={{ marginBottom: 6 }}>Estimated delivery</div>
            <div style={{ fontFamily: 'var(--serif)', fontSize: 16, lineHeight: 1.4 }}>
              May 5 – May 8, 2026<br />
              <span style={{ color: 'var(--ink-muted)', fontSize: 13 }}>Standard shipping</span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 32 }}>
        <button className="bw-btn bw-btn--outline" onClick={() => onNav('account')}>View order</button>
        <button className="bw-btn bw-btn--primary" onClick={() => onNav('shop')}>Keep shopping <Icon name="arrowSm" className="icon icon--sm" /></button>
      </div>
    </div>
  );
};

// =================== WISHLIST ===================
export const WishlistPage = ({ data, wishlist, onOpen, addToCart, toggleWish, onNav }) => {
  const items = data.products.filter(p => wishlist.includes(p.id));
  return (
    <div style={{ padding: '48px var(--pad-lg) var(--pad-xl)' }}>
      <span className="eyebrow">Saved</span>
      <h1 className="bw-cart-title" style={{ marginTop: 8 }}>Wishlist.</h1>
      <div className="bw-cart-count">{items.length} {items.length === 1 ? 'item' : 'items'} saved for later</div>
      {items.length === 0 ? (
        <div style={{ padding: '80px 0', textAlign: 'center', color: 'var(--ink-muted)' }}>
          <p>Nothing saved yet. Tap the heart on a product to keep it here.</p>
          <button className="bw-btn bw-btn--primary" style={{ marginTop: 24 }} onClick={() => onNav('shop')}>Shop coffee <Icon name="arrowSm" className="icon icon--sm" /></button>
        </div>
      ) : (
        <div className="bw-wishlist-grid">
          {items.map(p => <ProductCard key={p.id} p={p} onOpen={onOpen} onAdd={addToCart} wished={true} onWish={toggleWish} />)}
        </div>
      )}
    </div>
  );
};

// =================== ACCOUNT ===================
export const AccountPage = ({ user, onNav }) => {
  const [tab, setTab] = useState('orders');
  const orders = [
    { num: 'BR-548291', date: 'Apr 22, 2026', status: 'delivered', total: 64.50, items: 3 },
    { num: 'BR-541008', date: 'Apr 04, 2026', status: 'delivered', total: 24.00, items: 1 },
    { num: 'BR-538219', date: 'Mar 28, 2026', status: 'shipped', total: 89.00, items: 2 },
  ];
  return (
    <div className="bw-account">
      <aside className="bw-account-side">
        <h2>{user.name}</h2>
        <div className="bw-account-side-email">{user.email}</div>
        <nav className="bw-account-nav">
          <a className={tab === 'orders' ? 'active' : ''} onClick={() => setTab('orders')}>Orders <span style={{ opacity: 0.6, fontSize: 11 }}>{orders.length}</span></a>
          <a className={tab === 'address' ? 'active' : ''} onClick={() => setTab('address')}>Addresses</a>
          <a className={tab === 'payment' ? 'active' : ''} onClick={() => setTab('payment')}>Payment methods</a>
          <a className={tab === 'profile' ? 'active' : ''} onClick={() => setTab('profile')}>Profile & email</a>
          <a onClick={() => onNav('home')} style={{ marginTop: 24, color: 'var(--ink-faint)' }}>Sign out</a>
        </nav>
      </aside>
      <div className="bw-account-main">
        {tab === 'orders' && (
          <>
            <span className="eyebrow">Orders</span>
            <h1 style={{ marginTop: 8 }}>Your history.</h1>
            <div className="bw-orders">
              {orders.map(o => (
                <div key={o.num} className="bw-order-card">
                  <div>
                    <div className="bw-order-card-head">
                      <span className="bw-order-num">№ {o.num}</span>
                      <span className={`bw-order-status bw-order-status--${o.status}`}>{o.status}</span>
                      <span style={{ fontSize: 12, color: 'var(--ink-muted)' }}>{o.date}</span>
                    </div>
                    <div style={{ fontFamily: 'var(--serif)', fontSize: 18 }}>${o.total.toFixed(2)} · {o.items} items</div>
                    <div className="bw-order-thumbs">
                      {Array.from({ length: o.items }).map((_, i) => <div key={i} className="bw-order-mini-thumb"><div className="bw-order-mini-stripe"></div></div>)}
                    </div>
                  </div>
                  <button className="bw-btn bw-btn--ghost bw-btn--small">View order <Icon name="arrowSm" className="icon icon--sm" /></button>
                </div>
              ))}
            </div>
          </>
        )}
        {(tab === 'address' || tab === 'payment' || tab === 'profile') && (
          <>
            <span className="eyebrow">{tab === 'address' ? 'Addresses' : tab === 'payment' ? 'Payment methods' : 'Profile'}</span>
            <h1 style={{ marginTop: 8 }}>{tab === 'address' ? 'Where to send it.' : tab === 'payment' ? 'How you pay.' : 'Your details.'}</h1>
            <div style={{ padding: 32, marginTop: 32, border: '1px solid var(--line-soft)', borderRadius: 'var(--radius)', maxWidth: 520 }}>
              {tab === 'address' && (
                <>
                  <div style={{ fontFamily: 'var(--serif)', fontSize: 18, marginBottom: 8 }}>{user.name}</div>
                  <div style={{ color: 'var(--ink-muted)', lineHeight: 1.6 }}>237 Greenpoint Ave<br />Brooklyn, NY 11222<br />United States</div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                    <button className="bw-btn bw-btn--ghost bw-btn--small">Edit</button>
                    <button className="bw-btn bw-btn--ghost bw-btn--small">Add new</button>
                  </div>
                </>
              )}
              {tab === 'payment' && (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 40, height: 28, background: 'var(--ink)', color: 'var(--cream-pale)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--mono)', fontSize: 10, borderRadius: 3 }}>VISA</div>
                    <span style={{ fontFamily: 'var(--serif)', fontSize: 16 }}>•••• 4242</span>
                    <span style={{ color: 'var(--ink-muted)', fontSize: 13 }}>Exp 09/27</span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                    <button className="bw-btn bw-btn--ghost bw-btn--small">Add card</button>
                  </div>
                </>
              )}
              {tab === 'profile' && (
                <>
                  <div className="bw-form-row">
                    <div className="bw-field"><label>Name</label><input defaultValue={user.name} /></div>
                    <div className="bw-field"><label>Email</label><input defaultValue={user.email} /></div>
                  </div>
                  <button className="bw-btn bw-btn--primary bw-btn--small" style={{ marginTop: 12 }}>Save changes</button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// =================== AUTH ===================
export const AuthPage = ({ onLogin, onNav }) => {
  const [tab, setTab] = useState('signin');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const submit = (e) => {
    e.preventDefault();
    onLogin({ name: form.name || 'Sarah Kim', email: form.email || 'sarah@brewed.test' });
  };
  return (
    <div className="bw-auth">
      <div className="bw-auth-form">
        <span className="eyebrow">{tab === 'signin' ? 'Welcome back' : 'New here?'}</span>
        <h1 style={{ marginTop: 8 }}>{tab === 'signin' ? 'Sign in.' : 'Create an account.'}</h1>
        <div style={{ color: 'var(--ink-muted)', marginTop: 8, fontSize: 14 }}>Save your cart, wishlist, and addresses across visits.</div>
        <div className="bw-auth-tabs">
          <span className={`bw-auth-tab ${tab === 'signin' ? 'is-active' : ''}`} onClick={() => setTab('signin')}>Sign in</span>
          <span className={`bw-auth-tab ${tab === 'signup' ? 'is-active' : ''}`} onClick={() => setTab('signup')}>Create account</span>
        </div>
        <form onSubmit={submit}>
          {tab === 'signup' && (
            <div className="bw-field" style={{ marginBottom: 12 }}><label>Full name</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Sarah Kim" /></div>
          )}
          <div className="bw-field" style={{ marginBottom: 12 }}><label>Email</label><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@email.com" /></div>
          <div className="bw-field" style={{ marginBottom: 16 }}><label>Password</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" /></div>
          {tab === 'signin' && <div style={{ textAlign: 'right', fontSize: 12, marginBottom: 16 }}><a style={{ color: 'var(--accent)', cursor: 'pointer' }}>Forgot password?</a></div>}
          <button type="submit" className="bw-btn bw-btn--primary bw-btn--block bw-btn--large">{tab === 'signin' ? 'Sign in' : 'Create account'}</button>
        </form>
        <div className="bw-auth-divider">or continue with</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <button className="bw-btn bw-btn--ghost">Continue with Apple</button>
          <button className="bw-btn bw-btn--ghost">Continue with Google</button>
        </div>
      </div>
      <div className="bw-auth-img">
        <img src="/images/signin/signin.png" alt="Sign in" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(26,18,10,0.55) 0%, transparent 45%, rgba(26,18,10,0.3) 100%)' }} />
        <div className="bw-auth-quote" style={{ bottom: 'auto', top: 48, left: 48, right: 48, color: 'var(--cream-pale)', textShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>
          "The Yirgacheffe came roasted three days before it landed in my kitchen. Bright lemon, jasmine, that long sweet finish."
          <div className="bw-auth-quote-attr" style={{ color: 'rgba(239,228,210,0.7)', marginTop: 12 }}>— Sarah K. · New York, NY</div>
        </div>
      </div>
    </div>
  );
};